/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_Meta_OneInputs */



/**
* | output |
* | --- |
* | "1:1 · 1 meeting" |
*
* @param {Manager_Question_Meta_OneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_meta_one = /** @type {((inputs?: Manager_Question_Meta_OneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_Meta_OneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("1:1 · 1 gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("One-to-one · 1 entretien")
	return /** @type {LocalizedString} */ ("1:1 · 1 meeting")
});